import { uid } from 'uid';

export const NavLinks = [
  {
    id: uid(8),
    title: 'Service Portfolio',
    // url: '/services-portfolio',
    hasSubmenu: true,
    submenu: [
      {
        id: uid(8),
        title: 'Domestic Logistics',
        url: '/domestic-courier-solutions',
      },
      {
        id: uid(8),
        title: 'Corporate Logistics',
        url: '/corporate-courier-services',
      },
      {
        id: uid(8),
        title: 'Global Shipping',
        url: 'https://globalshipping.giglogistics.com/',
        hasSubmenu: true,
        external: true,
        submenu: [
          {
            id: uid(8),
            title: 'USA to Nigeria',
            url: 'https://globalshipping.giglogistics.com/shipping-from-usa-to-nigeria/',
            external: true,
          },
          {
            id: uid(8),
            title: 'Canada to Nigeria or Ghana',
            url: 'https://globalshipping.giglogistics.com/shipping-from-canada-to-nigeria-ghana/',
            external: true,
          },
          {
            id: uid(8),
            title: 'UK to Nigeria or Ghana',
            url: 'https://globalshipping.giglogistics.com/shipping-from-uk-to-nigeria-ghana/',
            external: true,
          },
          {
            id: uid(8),
            title: 'China to Nigeria or Ghana',
            url: 'https://globalshipping.giglogistics.com/shipping-from-china-to-nigeria-ghana/',
            external: true,
          },
          {
            id: uid(8),
            title: 'Ghana to Nigeria',
            url: 'https://globalshipping.giglogistics.com/shipping-from-ghana-to-nigeria/',
            external: true,
          },
        ],
      },
      {
        id: uid(8),
        title: 'E-commerce Logistics',
        url: '/ecommerce-logistics-services',
      },
      {
        id: uid(8),
        title: 'Wallet and Added Services',
        url: '/wallet-added-services',
      },
    ],
  },
  {
    id: uid(8),
    title: 'Our Offices',
    url: '/our-offices',
    // hasSubmenu: true,
    // submenu: [
    //   {
    //     id: uid(8),
    //     title: 'Nigeria',
    //     url: '/nigeria',
    //   },
    //   {
    //     id: uid(8),
    //     title: 'Ghana',
    //     url: '/ghana',
    //   },
    //   {
    //     id: uid(8),
    //     title: 'United States',
    //     url: '/united-states',
    //   },
    //   {
    //     id: uid(8),
    //     title: 'United Kingdom',
    //     url: '/united-kingdom',
    //   },
    //   {
    //     id: uid(8),
    //     title: 'China',
    //     url: '/china',
    //   },
    // ],
  },
  /*   {
    id: uid(8),
    title: 'Contact Us',
    url: '/contact-us',
  }, */
  {
    id: uid(8),
    title: 'Blog',
    url: 'https://globalshipping.giglogistics.com/blog/',
    external: true,
  },
  {
    id: uid(8),
    title: 'FAQs',
    url: '/faqs',
  },
  {
    id: uid(8),
    title: 'About Us',
    url: '/about-us',
  },
  {
    id: uid(8),
    title: 'Career',
    url: '/career-with-gigl',
  },
];
